import { createSelector } from 'reselect';

import { RegionalSettingNames, User, UserApps } from '@topconagriculture/frontend-utils';

import { RootState } from '../reducers';
import { Metric, getWeekStartsOn, metricMap, regionalSettingsConfig, uiConfig } from '../../config/constants';
import { getDateFormat } from '../../core/helpers/utils/utils';
import { UserDateSettings } from '../../core/shared.types';

export const getAppList = (state: RootState): UserApps => state.user.applications;
export const getUserProfile = (state: RootState): User | null => state.user.userProfile;
export const getLocale = (state: RootState): string => (state.user.userProfile ? state.user.userProfile.locale : 'en');

export const getRegionalSettingsSystem = (state: RootState) =>
  state.user.userProfile && state.user.userProfile.settings
    ? state.user.userProfile.settings.regionalSettingsName
    : uiConfig.defaultUom.system;

export const getRegionalSettingsName = (state: RootState): RegionalSettingNames =>
  state.user.userProfile && state.user.userProfile.settings
    ? state.user.userProfile.settings.regionalSettingsName
    : regionalSettingsConfig.regionFallback;

export const getUserDateSettings = createSelector(
  [getRegionalSettingsName, getLocale],
  (regionalSettingsName, locale): UserDateSettings => {
    const weekStartsOn = getWeekStartsOn[regionalSettingsName];
    const dateFormat = getDateFormat();
    return { weekStartsOn, dateFormat, locale: locale };
  },
);

export const getMetric = createSelector(
  [getRegionalSettingsSystem],
  (regionalSetting: string) => (metricRequested: Metric) => metricMap[regionalSetting][metricRequested],
);

export const getMetrics = createSelector(
  [getRegionalSettingsSystem],
  (regionalSetting: string) => () => metricMap[regionalSetting],
);

export const getFeedAppId = createSelector([getAppList], (apps: UserApps): string | undefined => {
  const feedApp = apps.find((app) => app.name === 'Feed');
  return feedApp ? feedApp.id : undefined;
});
